"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addArrowIconToWegfinderButtons = exports.normalizeRichTextButtonLinks = void 0;
function normalizeRichTextButtonLinks() {
    var links = document.querySelectorAll('a[class*="md-button-ic-"]');
    links.forEach(function (link) {
        var iconButtonClass = Array.from(link.classList).find(function (cssClass) { return cssClass.indexOf('md-button-ic-') === 0; });
        if (!iconButtonClass) {
            return;
        }
        var iconClassFromButtonClass = iconButtonClass.replace('md-button-', '');
        var iconClass = link.getAttribute('data-icon') || iconClassFromButtonClass;
        link.classList.remove(iconButtonClass);
        link.classList.add('md-button');
        if (!iconClass) {
            return;
        }
        var firstElementChild = link.firstElementChild;
        var hasLeadingIcon = !!firstElementChild && firstElementChild.tagName.toLowerCase() === 'span' && firstElementChild.classList.contains(iconClass);
        if (hasLeadingIcon) {
            firstElementChild.setAttribute('aria-hidden', 'true');
            return;
        }
        var iconElement = document.createElement('span');
        iconElement.classList.add(iconClass);
        iconElement.setAttribute('aria-hidden', 'true');
        link.insertBefore(iconElement, link.firstChild);
    });
}
exports.normalizeRichTextButtonLinks = normalizeRichTextButtonLinks;
function addArrowIconToWegfinderButtons() {
    var blueButtons = document.querySelectorAll('a.md-button-blue-wegfinder');
    blueButtons.forEach(function (button) {
        var hasIcon = button.querySelector('oebb-arrow-down-icon') !== null;
        if (!hasIcon) {
            var iconElement = document.createElement('oebb-arrow-down-icon');
            iconElement.setAttribute('width', '15');
            iconElement.setAttribute('height', '25');
            iconElement.setAttribute('aria-hidden', 'true');
            button.appendChild(iconElement);
        }
    });
}
exports.addArrowIconToWegfinderButtons = addArrowIconToWegfinderButtons;
